import { render, staticRenderFns } from "./AlarmContactForm.vue?vue&type=template&id=6f3adeea"
import script from "./AlarmContactForm.vue?vue&type=script&lang=js"
export * from "./AlarmContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports